<template>
    <div>
        <!-- Modal Repetição -->
        <div class="modal fade" id="repeticaoEscalaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Alocações</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!dados" />

                        <template v-else>
                            <div class="lead">
                                {{ dados.usuario.pessoa.st_nome }}
                            </div>

                            <div class="card">
                                <div class="card-body">
                                    <escala-agenda-show :agenda="dados.agenda" />
                                </div>
                            </div>

                            <h5>
                                <span class="badge badge-secondary">{{ dados.escalas.length }}</span>
                            </h5>

                            <ul class="list-group">
                                <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between" 
                                    :class="( escala.id_plantao_escala == id_plantao_escala ? 'active' : '' ) +
                                        ( ( escala.fl_ativo && escala.ch_status != 'C' ) ? '' : 'disabled' )"
                                    @click="id_plantao_escala = escala.id_plantao_escala"
                                    v-for="(escala, iex) in dados.escalas" :key="iex">
                                    <div>
                                        {{ $util.getFormatDate(escala.dt_escala) }}
                                        <div class="small">
                                            {{ $util.getFormatDate(escala.dt_escala, 'dddd') }}
                                        </div>
                                    </div>
                                    <div>
                                        <i class="fas fa-exchange-alt" title="Trocada" v-if="escala.ch_status == 'T'"></i>
                                        <i class="fas fa-hand-holding-usd" title="Vendida" v-if="escala.ch_status == 'V'"></i>
                                        <i class="fa fa-times" aria-hidden="true" title="Removida" v-if="!escala.fl_ativo || escala.ch_status == 'C'"></i>
                                    </div>
                                </button>
                            </ul>
                        </template>

                        <pre v-if="false">{{ dados }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="remover()" color="danger" v-if="atual">Remover</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import EscalaAgendaShow from './EscalaAgendaShow.vue';

export default {
    data() { 
        return { 
            dados: null, 
            id_plantao_escala: null, 
        };
    },

    components: { 
        AzEmptyState,
        AzSubmit, 
        EscalaAgendaShow, 
    },

    computed: { 
        atual: function () { 
            if ( !this.dados )
                return;

            return this.dados.escalas.find(item => item.id_plantao_escala == this.id_plantao_escala);
        }
    },

    methods: { 
        remover () { 
            if ( !confirm('Confirma remover as alocações realizadas a partir de ' 
                + this.$util.getFormatDate(this.atual.dt_escala) + '?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'plantao_repeticoes',
                func: 'remover', 
                dados: { 
                    id_plantao_repeticao: this.dados.id_plantao_repeticao,
                    id_plantao_escala: this.id_plantao_escala, 
                    cadastro: true, 
                },
                modal: 'repeticaoEscalaModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });

        },

        abrir(id_repeticao, id_plantao_escala = null) { 
            this.dados = null;
            this.id_plantao_escala = id_plantao_escala;

            this.$nextTick(() => { 

                $('#repeticaoEscalaModal').modal('show');

                this.$util.load(this, { 
                    service: 'plantao_repeticoes',
                    func: 'show', 
                    parms: { 
                        id: id_repeticao
                    },
                    loadTo: res => { 
                        this.dados = res;
                    }
                });

            });

        }
    }
}
</script>